var _style, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisualizzaNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2_00000098198111611843238440000006749855656934401955_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54.8 46.5",
    style: {
      enableBackground: "new 0 0 54.8 46.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-4_1_",
    className: "st0",
    d: "M27.5,30.9c-4.3,0-7.8-3.5-7.8-7.7s3.5-7.7,7.8-7.7s7.8,3.5,7.8,7.7S31.8,30.9,27.5,30.9z  M27.5,12.7c-5.9,0-10.7,4.7-10.7,10.5s4.8,10.5,10.7,10.5c5.9,0,10.7-4.7,10.7-10.5S33.4,12.7,27.5,12.7L27.5,12.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2,40.4C13.8,40.4,3.5,28,0.9,24.5c-0.3-0.1-0.5-0.4-0.7-0.7C0.1,23.5,0,23.3,0,23s0-0.6,0.2-0.8 c0.2-0.3,0.4-0.5,0.7-0.7C3.6,18,14.2,5.7,27.6,5.7s23.7,12.4,26.3,15.9c0.3,0.1,0.5,0.4,0.7,0.7c0.1,0.3,0.2,0.5,0.2,0.8 s0,0.6-0.2,0.8c-0.2,0.3-0.4,0.5-0.7,0.7C51.2,28,40.6,40.4,27.2,40.4z M3.5,23c2.6,3.3,12.1,14.4,23.7,14.4 c11.7,0,21.5-11.1,24.1-14.4C48.7,19.7,39.2,8.6,27.6,8.6C15.9,8.6,6.1,19.7,3.5,23z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 49.7,
    y1: 1.1,
    x2: 5.3,
    y2: 45.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.8,
    y: 21.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -8.3694 26.2486)",
    width: 62.7,
    height: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizzaNo);
export default __webpack_public_path__ + "static/media/visualizza_no.78467f07225f08c072772cf85970fd2d.svg";
export { ForwardRef as ReactComponent };